// Shared constants for profile activity, dietary, and mobility options.

export const ACTIVITY_SUGGESTIONS = [
  'coffee','brunch','lunch spots','fine dining','street food',
  'craft beer','wine bars','cocktail bars','rooftop bars','speakeasies',
  'Broadway shows','off-Broadway','comedy clubs','live music','concerts',
  'jazz clubs','art museums','galleries','film screenings',
  'golf','tennis','basketball','pickleball','cycling','running',
  'yoga','rock climbing','boxing',
  'Knicks games','Yankees games','Mets games','Rangers games','Brooklyn Nets','NYCFC',
  'Central Park','hiking','kayaking','beach days','High Line','Governors Island',
  'escape rooms','bowling','arcade bars','board game cafes',
  'cooking classes','bookstores','flea markets','nightlife',
];

export const DIETARY_OPTIONS = [
  'vegetarian','vegan','gluten-free','halal','kosher',
  'nut allergy','shellfish allergy','dairy-free','none',
];

export const MOBILITY_OPTIONS = [
  'wheelchair accessible required','no stairs','elevator required','none',
];
